// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b4824503","455":"10a099ef"}[chunkId] + ".chunk.js";
};